// extracted by mini-css-extract-plugin
export default {"label":"InputFile_label__vB12p","hidden":"InputFile_hidden__HFDS5","text":"InputFile_text__uMrd9"};